import { Address, OpenedContract, Transaction } from "@ton/core";
import { LendingType } from "../entities/Lending/LendingTypes";
import { OfferType } from "../entities/Offer/OfferTypes";
import { LendingPoolOp } from "../hooks/useLaunchLending";
import { CollectionOfferPoolOp } from "../hooks/useLaunchOffer";
import { RafflePoolOp } from "../hooks/useLaunchRaffle";
import { SalePoolOp } from "../hooks/useLaunchSale";
import { ContractsType as RaffleContractsType } from "../lib/versions/contracts/raffle.code";
import { ContractsType } from "../lib/versions/contracts/sale.code";
import { NFTItem } from "../lib/wrappers/NFTItem";
import TonClientStore from "../stores/TonClientStore/TonClientStore";
import { CheckTransactionOutput } from "./checkTransactionsWithWhile";

export async function checkNFTOwner(
  nftAddress: string,
  newOwnerAddress: string,
  tonClientStore: TonClientStore
): Promise<boolean> {
  if (!tonClientStore.tonClient || !tonClientStore.sender) {
    return false;
  }

  try {
    const nft = tonClientStore.tonClient?.open(
      NFTItem.createFromAddress(Address.parse(nftAddress))
    );

    return (
      (await nft?.getOwner())?.toRawString() ===
      Address.parse(newOwnerAddress).toRawString()
    );
  } catch (_: unknown) {
    return false;
  }
}

// TODO: rename func to checkTransactionWithMasterAddress
export async function checkOtherMarketplaceTransactions(
  masterAddress: Address,
  id: bigint,
  startTime: number,
  opcode: SalePoolOp | CollectionOfferPoolOp | LendingPoolOp | number,
  tonClientStore: TonClientStore
): Promise<CheckTransactionOutput> {
  if (!tonClientStore.tonClient || !tonClientStore.sender) {
    return CheckTransactionOutput.noTonClient;
  }

  try {
    const transactions = await tonClientStore.tonClient.getTransactions(
      masterAddress,
      {
        limit: 1000,
      }
    );

    // console.log("nik transactions", transactions);

    let currentTransaction: Transaction | undefined;
    // console.log("nik before loop ", startTime);
    for (const tx of transactions) {
      // console.log("nik tx now ", tx.now, "startTime", startTime);

      if (tx && tx.now > startTime) {
        const body = tx.inMessage?.body.asSlice();
        // console.log("nik get body ");

        if (body) {
          const op = body.loadUint(32);
          // console.log("nik op", op, "opcode", opcode);

          if (op === opcode) {
            currentTransaction = tx;
            break; // нашли подходящую транзакцию, выходим из цикла
          }
        }
      }
    }

    if (!currentTransaction) {
      return CheckTransactionOutput.noCurrentTransaction;
    }

    const bodySlice = currentTransaction.inMessage?.body.asSlice();
    if (!bodySlice) {
      return CheckTransactionOutput.noCurrentTransactionBody;
    }

    const op = bodySlice.loadUint(32);

    if (op === opcode) {
      return CheckTransactionOutput.success;
    }

    return CheckTransactionOutput.nonPurchaseTransaction;
  } catch (_: unknown) {
    return CheckTransactionOutput.errorCatched;
  }
}

export async function checkTransactionGeneric(
  master:
    | OpenedContract<ContractsType>
    | OpenedContract<RaffleContractsType>
    | OpenedContract<OfferType>
    | OpenedContract<LendingType>,
  id: bigint,
  startTime: number,
  opcode: SalePoolOp | RafflePoolOp | CollectionOfferPoolOp | LendingPoolOp,
  tonClientStore: TonClientStore
): Promise<CheckTransactionOutput> {
  if (!tonClientStore.tonClient || !tonClientStore.sender) {
    return CheckTransactionOutput.noTonClient;
  }

  try {
    const transactions = await tonClientStore.tonClient.getTransactions(
      master.address,
      {
        limit: 1000,
      }
    );

    let currentTransaction: Transaction | undefined;

    for (const tx of transactions) {
      if (tx && tx.now > startTime) {
        const body = tx.inMessage?.body.asSlice();

        if (body) {
          const op = body.loadUint(32);
          // console.log("nik op", op, "opcode", opcode);
          if (op === opcode) {
            currentTransaction = tx;
            break; // нашли подходящую транзакцию, выходим из цикла
          }
        }
      }
    }

    if (!currentTransaction) {
      return CheckTransactionOutput.noCurrentTransaction;
    }

    const bodySlice = currentTransaction.inMessage?.body.asSlice();

    if (!bodySlice) {
      return CheckTransactionOutput.noCurrentTransactionBody;
    }

    const op = bodySlice.loadUint(32);

    if (op === opcode) {
      return CheckTransactionOutput.success;
    }

    return CheckTransactionOutput.nonPurchaseTransaction;
  } catch (_: unknown) {
    return CheckTransactionOutput.errorCatched;
  }
}
